<template>
<div>
    <button class="btn-delete">
        <i class="material-icons">close</i>
    </button>
</div>
</template>

<script>
export default {
    name: "button-delete"
}
</script>

<style lang="scss" scoped>
.btn-delete {
    border: none;
    background-color: transparent;
    //  color: red; 
    cursor: pointer;
    
}
</style>
